function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('.qty');
      this.step = parseFloat(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', { bubbles: true });

      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.changeQuantity(-1 * this.step));
      this.add.addEventListener('click', () => this.changeQuantity(1 * this.step));

      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    changeQuantity(change) {
      let quantity = parseInt(this.input.value) || 0;

      // Update quantity
      const newValue = Math.max(quantity + change, 1);

      // Check min and max values
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;
      if (newValue < min || newValue > max) return;

      // Update input value
      this.input.value = newValue;

      // Dispatch change event
      this.input.dispatchEvent(this.changeEvent);

      // Update button states
      this.validateQtyRules();
    }

    validateQtyRules() {
      const value = parseInt(this.input.value) || 0;
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;

      this.subtract.classList.toggle('disabled', value <= min);
      this.add.classList.toggle('disabled', value >= max);
    }
  }

  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.carousel_images = this.querySelectorAll('.product-card-carousel-image');
      this.prev_button = this.querySelector('.product-card-nav-prev');
      this.next_button = this.querySelector('.product-card-nav-next');
      this.image_counter = this.querySelector('.product-card-image-counter');
      this.counter_current = this.querySelector('.product-card-image-counter-current');
      this.current_image_index = 0;
    }
    connectedCallback() {
      this.carousel_images = this.querySelectorAll('.product-card-carousel-image');
      this.prev_button = this.querySelector('.product-card-nav-prev');
      this.next_button = this.querySelector('.product-card-nav-next');
      this.image_counter = this.querySelector('.product-card-image-counter');
      this.counter_current = this.querySelector('.product-card-image-counter-current');
      this.image = this.querySelector('.product-card-image-link .product-primary-image');
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.querySelector('.product-card-related-products')) {
        this.enableRelatedThumbs();
      }
      if (this.prev_button || (this.carousel_images && this.carousel_images.length > 1)) {
        this.enableAdditionalImages();
      } else if (this.carousel_images && this.carousel_images.length === 1) {
        this.carousel_images[0].classList.add('active');
      } else if (this.additional_images && this.additional_images.length) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      if (this.carousel_images && this.carousel_images.length && this.prev_button) {
        const counter_total = this.querySelector('.product-card-image-counter-total');

        this._updateCarouselIndex = (index) => {
          const images = Array.from(this.querySelectorAll('.product-card-carousel-image')).filter((img) => img.style.display !== 'none');
          const total_images = images.length;

          if (!total_images) {
            return;
          }

          // Loop infinito: después de la última vuelve a la primera, y al revés.
          index = ((index % total_images) + total_images) % total_images;

          images.forEach((img, i) => {
            img.classList.toggle('active', i === index);
          });
          this.current_image_index = index;

          if (this.counter_current) {
            this.counter_current.textContent = index + 1;
          }
          if (counter_total) {
            counter_total.textContent = total_images;
          }
          if (this.image_counter) {
            this.image_counter.hidden = total_images <= 1;
          }
          if (this.prev_button) {
            this.prev_button.classList.toggle('active', total_images > 1);
            this.prev_button.disabled = total_images <= 1;
            this.prev_button.hidden = total_images <= 1;
          }
          if (this.next_button) {
            this.next_button.classList.toggle('active', total_images > 1);
            this.next_button.disabled = total_images <= 1;
            this.next_button.hidden = total_images <= 1;
          }
          this.syncGalleryBars(index, total_images);
        };

        this.querySelectorAll('.product-card-carousel-image').forEach((img) => {
          img.style.display = 'block';
          img.style.visibility = 'visible';
        });
        this._updateCarouselIndex(0);

        if (this.prev_button && !this.prev_button.dataset.carouselBound) {
          this.prev_button.dataset.carouselBound = 'true';
          this.prev_button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this._updateCarouselIndex(this.current_image_index - 1);
          });
        }

        if (this.next_button && !this.next_button.dataset.carouselBound) {
          this.next_button.dataset.carouselBound = 'true';
          this.next_button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this._updateCarouselIndex(this.current_image_index + 1);
          });
        }

        const images = Array.from(this.carousel_images);
        images.forEach(function (image) {
          if (image.dataset.srcset || image.dataset.src) {
            if (typeof lazySizes !== 'undefined' && lazySizes.loader) {
              lazySizes.loader.unveil(image);
            } else {
              if (image.dataset.srcset) {
                image.srcset = image.dataset.srcset;
              }
              if (image.dataset.src) {
                image.src = image.dataset.src;
              }
            }
          }
        });

        this.enableCarouselSwipe();

        return;
      }

      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      window.addEventListener('load', () => {
        images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableCarouselSwipe() {
      if (this.closest('.lop-wishlist-cards')) {
        return;
      }
      const container = this.querySelector('.product-card-image');
      if (!container || container.dataset.carouselSwipeBound === 'true') {
        return;
      }
      container.dataset.carouselSwipeBound = 'true';

      const swipeThreshold = 40;
      const lockThreshold = 8;
      let startX = 0;
      let startY = 0;
      let tracking = false;
      let axis = null;
      let didSwipe = false;

      const touchPoint = (event) => {
        if (event.changedTouches && event.changedTouches[0]) {
          return event.changedTouches[0];
        }
        if (event.touches && event.touches[0]) {
          return event.touches[0];
        }
        return null;
      };

      const visibleCount = () => {
        return Array.from(this.querySelectorAll('.product-card-carousel-image')).filter((img) => img.style.display !== 'none').length;
      };

      container.addEventListener('touchstart', (event) => {
        if (event.target.closest('.product-card-nav, .product-card-related-products, .wishlist-engine, quick-view, .product-card-compare')) {
          return;
        }
        if (typeof this._updateCarouselIndex !== 'function' || visibleCount() <= 1) {
          return;
        }
        const point = touchPoint(event);
        if (!point) {
          return;
        }
        startX = point.clientX;
        startY = point.clientY;
        tracking = true;
        axis = null;
        didSwipe = false;
      }, { passive: true });

      container.addEventListener('touchmove', (event) => {
        if (!tracking) {
          return;
        }
        const point = touchPoint(event);
        if (!point) {
          return;
        }
        const dx = point.clientX - startX;
        const dy = point.clientY - startY;
        if (axis === null && (Math.abs(dx) > lockThreshold || Math.abs(dy) > lockThreshold)) {
          axis = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
        }
        if (axis === 'h' && event.cancelable) {
          event.preventDefault();
        }
      }, { passive: false });

      container.addEventListener('touchend', (event) => {
        if (!tracking) {
          return;
        }
        tracking = false;
        if (axis !== 'h' || typeof this._updateCarouselIndex !== 'function') {
          axis = null;
          return;
        }
        const point = touchPoint(event);
        axis = null;
        if (!point) {
          return;
        }
        const dx = point.clientX - startX;
        if (Math.abs(dx) < swipeThreshold) {
          return;
        }
        didSwipe = true;
        if (dx < 0) {
          this._updateCarouselIndex(this.current_image_index + 1);
        } else {
          this._updateCarouselIndex(this.current_image_index - 1);
        }
      });

      container.addEventListener('click', (event) => {
        if (!didSwipe) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        didSwipe = false;
      }, true);
    }
    syncGalleryBars(index, total) {
      const bars = this.querySelector('.lop-plp-card-gallery-bars');
      if (!bars) {
        return;
      }
      if (total <= 1) {
        bars.hidden = true;
        return;
      }
      bars.hidden = false;
      if (bars.children.length !== total) {
        const frag = document.createDocumentFragment();
        for (let i = 0; i < total; i += 1) {
          const span = document.createElement('span');
          span.setAttribute('data-active', i === index ? 'true' : 'false');
          frag.appendChild(span);
        }
        bars.replaceChildren(frag);
        return;
      }
      Array.from(bars.children).forEach((span, i) => {
        span.setAttribute('data-active', i === index ? 'true' : 'false');
      });
    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch');
      this.color_index = this.swatches.dataset.index;
      this.org_srcset = this.image ? this.image.dataset.srcset : '';

      this.addEventListener('change', this.onSwatchChange.bind(this));

      swatch_list.forEach((swatch) => {
        window.addEventListener('load', () => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('click', this.onSwatchClick);
        swatch.addEventListener('mouseover', this.onSwatchHover);
      });

      // Manejar click en el elemento "+X" de variantes restantes usando delegación de eventos
      this.addEventListener('click', (e) => {
        let remainingElement = e.target.closest('.product-card-swatches--remaining');
        if (remainingElement) {
          e.preventDefault();
          e.stopPropagation();
          let href = remainingElement.dataset.href || remainingElement.getAttribute('href');
          if (href) {
            window.location.href = href;
          }
        }
      });
    }
    onSwatchClick() {
      window.location.href = this.dataset.href;
    }
    onSwatchHover() {
      let swatch_input = this.previousElementSibling;
      swatch_input.checked = true;
      swatch_input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    onSwatchChange(evt) {
      if (this.image) {
        if (evt.target.dataset.srcset) {
          this.image.setAttribute('srcset', evt.target.dataset.srcset);
        } else {
          this.image.setAttribute('srcset', this.org_srcset);
        }
      }
    }
    enableRelatedThumbs() {
      const container = this.querySelector('.product-card-related-products');
      if (!container || container.dataset.thumbsBound) {
        return;
      }

      container.dataset.thumbsBound = 'true';

      container.querySelectorAll('.product-card-related-thumb').forEach((thumb) => {
        ProductCard.registerThumbImages(thumb);
      });

      container.addEventListener('pointerenter', (evt) => {
        const thumb = evt.target.closest('.product-card-related-thumb');
        if (!thumb || !container.contains(thumb)) {
          return;
        }

        ProductCard.preloadProductImages(ProductCard.getImagesFromThumb(thumb), 2);
      }, true);

      container.addEventListener('click', (evt) => {
        const thumb = evt.target.closest('.product-card-related-thumb');
        if (!thumb || !container.contains(thumb) || thumb.classList.contains('product-card-related-products__more')) {
          return;
        }

        evt.preventDefault();
        evt.stopPropagation();

        if (thumb.classList.contains('product-card-related-thumb--active') || thumb.classList.contains('product-card-related-products__item--active')) {
          return;
        }

        const handle = thumb.dataset.productHandle;
        const productUrl = thumb.getAttribute('href');

        container.querySelectorAll('.product-card-related-thumb').forEach((item) => {
          item.classList.remove('product-card-related-thumb--active', 'product-card-related-products__item--active');
          item.removeAttribute('aria-current');
        });
        thumb.classList.add('product-card-related-thumb--active', 'product-card-related-products__item--active');
        thumb.setAttribute('aria-current', 'true');

        const imageUrls = ProductCard.getProductImages(handle, this, thumb);
        if (imageUrls.length) {
          this.switchVariantImages(imageUrls, productUrl, handle);
          return;
        }

        ProductCard.fetchProductImages(handle).then((resolvedUrls) => {
          this.switchVariantImages(resolvedUrls, productUrl, handle);
        });
      });

      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(() => {
          container.querySelectorAll('.product-card-related-thumb').forEach((thumb) => {
            ProductCard.preloadProductImages(ProductCard.getImagesFromThumb(thumb), 1);
          });
        }, { timeout: 2000 });
      }
    }
    static parseProductImages(rawValue) {
      if (!rawValue) {
        return [];
      }

      return rawValue.split('||').map((url) => url.trim()).filter(Boolean);
    }
    static registerThumbImages(thumb) {
      const handle = thumb?.dataset?.productHandle;
      const images = ProductCard.getImagesFromThumb(thumb);

      if (!handle || !images.length) {
        return;
      }

      if (!ProductCard._imageCache) {
        ProductCard._imageCache = {};
      }

      ProductCard._imageCache[handle] = images;
    }
    static getImagesFromThumb(thumb) {
      if (!thumb) {
        return [];
      }

      if (thumb.dataset.productImages) {
        return ProductCard.parseProductImages(thumb.dataset.productImages);
      }

      const handle = thumb.dataset.productHandle;
      if (handle && ProductCard._imageCache?.[handle]) {
        return ProductCard._imageCache[handle];
      }

      return [];
    }
    static getProductImages(handle, contextCard, thumb) {
      const thumbImages = ProductCard.getImagesFromThumb(thumb);
      if (thumbImages.length) {
        return thumbImages;
      }

      if (!ProductCard._imageCache) {
        ProductCard._imageCache = {};
      }

      if (handle && ProductCard._imageCache[handle]) {
        return ProductCard._imageCache[handle];
      }

      const card = handle
        ? document.querySelector('product-card[data-product-handle="' + CSS.escape(handle) + '"]')
        : null;
      if (card) {
        const images = ProductCard.parseProductImages(card.getAttribute('data-product-images'));
        if (images.length) {
          ProductCard._imageCache[handle] = images;
          return images;
        }
      }

      if (contextCard && contextCard.getAttribute('data-product-handle') === handle) {
        const images = ProductCard.parseProductImages(contextCard.getAttribute('data-product-images'));
        if (images.length) {
          ProductCard._imageCache[handle] = images;
          return images;
        }
      }

      return [];
    }
    static fetchProductImages(handle) {
      if (!handle) {
        return Promise.resolve([]);
      }

      if (!ProductCard._fetchCache) {
        ProductCard._fetchCache = {};
      }

      if (ProductCard._fetchCache[handle]) {
        return ProductCard._fetchCache[handle];
      }

      if (!ProductCard._imageCache) {
        ProductCard._imageCache = {};
      }

      const root = window.Shopify?.routes?.root || '/';
      ProductCard._fetchCache[handle] = fetch(root + 'products/' + handle + '.js')
        .then((response) => response.json())
        .then((product) => {
          const images = (product.images || []).map((image) => image.src || image).filter(Boolean);
          ProductCard._imageCache[handle] = images;
          return images;
        })
        .catch(() => [])
        .finally(() => {
          delete ProductCard._fetchCache[handle];
        });

      return ProductCard._fetchCache[handle];
    }
    static preloadProductImages(imageUrls, limit) {
      if (!imageUrls || !imageUrls.length) {
        return;
      }

      if (!ProductCard._preloaded) {
        ProductCard._preloaded = new Set();
      }

      imageUrls.slice(0, limit || imageUrls.length).forEach((url) => {
        if (!url || ProductCard._preloaded.has(url)) {
          return;
        }

        ProductCard._preloaded.add(url);
        const img = new Image();
        img.decoding = 'async';
        img.src = url;
      });
    }
    static warmImageCache() {
      if (!ProductCard._imageCache) {
        ProductCard._imageCache = {};
      }

      document.querySelectorAll('product-card[data-product-handle][data-product-images]').forEach((card) => {
        const handle = card.getAttribute('data-product-handle');
        const images = ProductCard.parseProductImages(card.getAttribute('data-product-images'));
        if (handle && images.length) {
          ProductCard._imageCache[handle] = images;
        }
      });

      document.querySelectorAll('.product-card-related-thumb[data-product-handle]').forEach((thumb) => {
        ProductCard.registerThumbImages(thumb);
      });
    }
    switchVariantImages(imageUrls, productUrl, productHandle) {
      if (!imageUrls || !imageUrls.length) {
        return;
      }

      if (productUrl) {
        this.updateCardLinks(productUrl);
        this.setAttribute('data-product-url', productUrl);
      }

      if (productHandle) {
        this.setAttribute('data-product-handle', productHandle);
        const quickView = this.querySelector('quick-view');
        if (quickView) {
          quickView.setAttribute('data-product-handle', productHandle);
        }
        const atc = this.querySelector('.product-card--add-to-cart-button');
        if (atc) {
          atc.setAttribute('data-product-handle', productHandle);
        }
      }

      const carouselImages = Array.from(this.querySelectorAll('.product-card-carousel-image'));
      const imageLink = this.querySelector('.product-card-image-link');

      if (carouselImages.length && imageLink) {
        carouselImages.forEach((img, index) => {
          if (index < imageUrls.length) {
            this.setImageElementSrc(img, imageUrls[index]);
            img.style.display = 'block';
            img.style.visibility = 'visible';
          } else {
            img.style.display = 'none';
            img.classList.remove('active');
          }
        });

        if (imageUrls.length > carouselImages.length) {
          const template = carouselImages[0] || this.image;
          for (let i = carouselImages.length; i < imageUrls.length; i += 1) {
            const clone = template.cloneNode(true);
            clone.classList.remove('active', 'product-primary-image');
            clone.classList.add('product-secondary-image', 'product-card-carousel-image');
            this.setImageElementSrc(clone, imageUrls[i]);
            imageLink.appendChild(clone);
          }
        }

        this.carousel_images = this.querySelectorAll('.product-card-carousel-image');
        this.prev_button = this.querySelector('.product-card-nav-prev');
        this.next_button = this.querySelector('.product-card-nav-next');
        this.image = this.querySelector('.product-card-image-link .product-primary-image') || this.carousel_images[0];

        const figure = this.querySelector('.product-card-image');
        if (figure) {
          figure.setAttribute('data-total-images', String(imageUrls.length));
        }

        if (typeof this._updateCarouselIndex === 'function') {
          this._updateCarouselIndex(0);
          this.enableCarouselSwipe();
        } else if (this.prev_button) {
          this.enableAdditionalImages();
        } else if (this.carousel_images.length) {
          this.carousel_images.forEach((img, index) => {
            img.classList.toggle('active', index === 0);
          });
        }
      } else if (this.image) {
        this.setImageElementSrc(this.image, imageUrls[0]);
      }
    }
    updateCardLinks(productUrl) {
      this.querySelectorAll('.product-card__full-link, .product-card-image-link, .product-card-title, .product-card--view-details').forEach((link) => {
        link.href = productUrl;
      });
    }
    setImageElementSrc(img, url) {
      if (!img || !url) {
        return;
      }

      const srcset = url.replace(/width=\d+/, 'width=375') + ' 375w, ' + url + ' 770w';
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
      img.loading = 'eager';
      img.src = url;
      img.srcset = srcset;
      img.dataset.src = url;
      img.dataset.srcset = srcset;

      if (typeof img.decode === 'function') {
        img.decode().catch(() => {});
      }
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    renderContents(parsedState) {
      // En rutas de app proxy (/apps/*) Shopify no resuelve sections_url y devuelve sections null.
      if (!parsedState.sections) {
        this.fetchCartSections().then((sections) => this.updateCartSections(sections));
        return;
      }
      this.updateCartSections(parsedState.sections);
    }
    fetchCartSections() {
      const sections = this.getSectionsToRender()
        .filter((section) => document.getElementById(section.id))
        .map((section) => section.section);
      const unique = sections.filter((section, index) => sections.indexOf(section) === index);

      if (!unique.length) {
        return Promise.resolve(null);
      }
      return fetch(`${theme.routes.root_url}?sections=${unique.join(',')}`)
        .then((response) => response.json())
        .catch((e) => {
          console.error(e);
          return null;
        });
    }
    updateCartSections(sections) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const sectionHTML = sections ? sections[section.section] : null;
        if (!sectionHTML) {
          return;
        }
        const innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
        if (innerHTML == null) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = innerHTML;
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ProductCard.warmImageCache());
  } else {
    ProductCard.warmImageCache();
  }
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      panel.classList.remove('active');
      document.body.classList.remove('open-cc');
      panel.setAttribute('inert', '');
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.isOpen = false;
      this.button = document.getElementById('cart-drawer-toggle');

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.removeProductEvent();

      document.addEventListener('click', this.onWindowClick.bind(this));

      // Add functionality to button
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.isOpen ? this.close() : this.open();
      });

      // Add functionality to close button
      this.addEventListener('click', (e) => {
        if (e.target.closest('.cart-drawer--close')) {
          e.preventDefault();
          this.close();
        }
      });

      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          const productModal = document.getElementById('Product-Modal');
          if (productModal && productModal.hasAttribute('open')) {
            return;
          }
          this.close();
        }
      });
    }

    onWindowClick(event) {
      if (event.target.closest('#Product-Modal, .product-modal')) {
        return;
      }
      if (!this.contains(event.target) && this.isOpen && !this.button.contains(event.target)) {
        this.close();
      }
    }
    open() {
      this.removeAttribute('inert');
      this.focus();
      this.isOpen = true;
      document.body.classList.add('cart-drawer-open');
      document.documentElement.classList.add('cart-drawer-open');
      dispatchCustomEvent('cart-drawer:open');
    }
    close() {
      this.setAttribute('inert', '');
      this.isOpen = false;
      document.body.classList.remove('cart-drawer-open');
      document.documentElement.classList.remove('cart-drawer-open');
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {

      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.currentTarget.dataset.index, '0');
          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer--inner'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          if (this.querySelector(`#CartDrawerItem-${line}`)) {
            this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
          }
        });
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('[name="locale_code"], [name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function ResizeSelect
 */
if (!customElements.get('resize-select')) {
  class ResizeSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.select = this.querySelector('select');
      this.addEventListeners();
    }
    addEventListeners() {
      this.addEventListener('change', this.resizeSelect.bind(this));
      window.addEventListener('load', this.resizeSelect.bind(this));
      this.resizeSelect();
    }
    resizeSelect() {
      let tempOption = document.createElement('option');
      tempOption.textContent = this.select.selectedOptions[0].textContent;

      let tempSelect = document.createElement('select'),
        offset = 10;
      tempSelect.style.visibility = 'hidden';
      tempSelect.style.position = 'fixed';
      tempSelect.appendChild(tempOption);
      this.after(tempSelect);
      if (tempSelect.clientWidth > 0) {
        this.select.style.width = `${+tempSelect.clientWidth + offset}px`;
      }
      tempSelect.remove();
    }
  }
  customElements.define('resize-select', ResizeSelect);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Modal');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.addEventListener('keypress', this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      if (e.key && e.key !== 'Enter') {
        return;
      }
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Modal-Content').innerHTML;
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Modal-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Modal-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.drawer.setAttribute('open', '');
        const closeToggle = this.drawer.querySelector('.product-modal__toggle');
        if (closeToggle) {
          closeToggle.focus();
        }

        this.refreshQuickViewGallery();

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
    refreshQuickViewGallery() {
      const slider = this.drawer ? this.drawer.querySelector('#Product-Slider') : null;
      if (!slider) {
        return;
      }

      const refresh = () => {
        if (!slider.isConnected) {
          return;
        }
        if (typeof slider.reInit === 'function') {
          slider.reInit();
        } else if (slider.flkty && typeof slider.flkty.resize === 'function') {
          slider.flkty.resize();
        }
        window.dispatchEvent(new Event('resize'));
      };

      const images = Array.from(slider.querySelectorAll('img'));
      const imagesReady = !images.length || images.every((img) => img.complete && img.naturalWidth > 0)
        ? Promise.resolve()
        : Promise.all(images.map((img) => {
          if (img.complete && img.naturalWidth > 0) {
            return Promise.resolve();
          }
          return new Promise((resolve) => {
            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
          });
        }));

      const timeoutId = setTimeout(refresh, 2000);
      imagesReady.then(() => {
        clearTimeout(timeoutId);
        requestAnimationFrame(refresh);
      });
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function ThemeScroll
 */
if (!customElements.get('theme-scroll')) {
  class ThemeScroll extends HTMLElement {
    constructor() {
      super();

      this.viewport = this.querySelector('.theme-scroll--inner');
      this.slideWidth = 274;
      this.slidesToScroll = 1;
    }
    connectedCallback() {
      window.OverlayScrollbarsGlobal.OverlayScrollbars({
        target: this,
        elements: {
          viewport: this.viewport,
        }
      }, {});

      this.init();
    }
    init() {
      this.setSlides();
      this.reachedEnd = 0;

      if (this.slides.length < 1) {
        return;
      }
      this.nav = this.querySelector('.theme-scroll-nav');
      this.navPrev = this.querySelector('.flickity-prev');
      this.navNext = this.querySelector('.flickity-next');
      this.resizeObserver = new ResizeObserver((entries) => {
        this.slideWidth = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == this.viewport.scrollLeft;
        this.onNavDisabled();
      }, {
        root: this
      });
      this.debouncedOnScroll = debounce((event) => {
        this.onScroll(event);
      }, 100);

      this.setListeners();
      this.centerArrows();
    }
    setSlides() {
      this.slides = this.querySelectorAll('.carousel__slide');
      this.slidesLength = this.slides.length;
      this.lastSlide = this.slides[this.slides.length - 1];
    }
    setListeners() {
      this.nav.addEventListener('click', this.onNavClick.bind(this));
      this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
      this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
      this.resizeObserver.observe(this.slides[0]);
    }
    onScroll() {
      this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == Math.floor(this.viewport.scrollLeft);
      this.onNavDisabled();
    }
    onNavClick(e) {
      if (!e.target.matches('.flickity-nav')) {
        return;
      }
      if (e.target.name === 'next') {
        this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
      } else if (e.target.name === 'prev') {
        this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
      }
      this.viewport.scrollTo({
        left: this.scrollPos,
        behavior: "smooth"
      });
    }
    onNavDisabled() {
      if (this.navPrev) {
        this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
      }
      if (this.navNext) {
        this.navNext.disabled = this.reachedEnd ? 1 : 0;
      }
    }
    centerArrows() {
      let first_cell = this.slides[0],
        max_height = 0,
        image_height = 0;
      if (first_cell.querySelector('.product-card-image')) {
        image_height = first_cell.querySelector('.product-card-image').clientHeight;
      } else if (first_cell.querySelector('.gallery--item')) {
        image_height = this.slides[1].querySelector('.product-card-image').clientHeight;
      }
      if (image_height > 0) {
        this.slides.forEach((item, i) => {
          if (item.clientHeight > max_height) {
            max_height = item.clientHeight;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;

          this.navPrev.style.transform = 'translateY(' + difference + 'px)';
          this.navNext.style.transform = 'translateY(' + difference + 'px)';
        }
      }
    }
  }
  customElements.define('theme-scroll', ThemeScroll);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.collapsed_mobile = this.classList.contains('accordion--collapsed-mobile');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (this.initialized) { return; }
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));

      this.initialized = true;
      if (this.collapsed_mobile) {
        window.addEventListener('resize', () => {
          this.details.open = window.innerWidth > 768;
        });
        window.dispatchEvent(new Event('resize'));
      }
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';

      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';

      this.dispatchEvent(new Event('animationend', { bubbles: false }));
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  let scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
});